<template>
  <div>
    <div class="border-b border-gray-200">
      <nav class="flex justify-center" aria-label="Tabs">
        <div
          :class="[
            'border-b-2 w-full',
            tab === 'historico' ? 'border-[#2F7F91]' : 'border-transparent'
          ]"
        >
          <button
            @click="tab = 'historico'"
            :class="[
              'py-3 md:py-4 px-2 text-sm md:text-base transition-colors focus:outline-none',
              tab === 'historico' ? 'text-gray-900 font-bold' : 'text-gray-500 hover:text-gray-700'
            ]"
          >
            Histórico de trocas de plantão
          </button>
        </div>

        <div
          :class="[
            'border-b-2 w-full',
            tab === 'consulta' ? 'border-[#2F7F91]' : 'border-transparent'
          ]"
        >
          <button
            @click="tab = 'consulta'"
            :class="[
              'py-3 md:py-4 px-2 text-sm md:text-base transition-colors focus:outline-none',
              tab === 'consulta' ? 'text-gray-900 font-bold' : 'text-gray-500 hover:text-gray-700'
            ]"
          >
            Consulta de plantões
          </button>
        </div>
      </nav>
    </div>

    <div v-show="tab === 'historico'">
      <ShiftChangeHistory :is-active="tab === 'historico'" />
    </div>

    <div v-show="tab === 'consulta'">
      <CheckShift />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import CheckShift from './CheckShift.vue'
import ShiftChangeHistory from './ShiftChangeHistory.vue'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'

const headerStore = useHeaderStore()

const tab = ref('historico')

onMounted(() => {
  headerStore.setTitle(
    'Consultar Plantões',
    'Consulte plantões e acompanhe o histórico de trocas realizadas'
  )
})
</script>
